"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_stripe_elements_1 = require("react-stripe-elements");
var VerifyPaymentCardStrings_1 = __importDefault(require("../VerifyPaymentCardStrings"));
var CardFieldsStyles_1 = require("./CardFieldsStyles");
var StripeInput_1 = __importDefault(require("./StripeInput"));
var PostalCode = function (_a) {
    var onChange = _a.onChange, error = _a.error;
    return (React.createElement(StripeInput_1["default"], { labelName: VerifyPaymentCardStrings_1["default"].cardZipCode(), error: error },
        React.createElement(react_stripe_elements_1.PostalCodeElement, { style: CardFieldsStyles_1.stripeStyle, onChange: function (response) {
                return onChange(response.empty, response.error && VerifyPaymentCardStrings_1["default"].invalid(), response.complete);
            } })));
};
exports["default"] = PostalCode;
